import { userGoalsApi } from '@/api'
import { IUserGoal } from './types'

export const getUserGoals = async (userId: number): Promise<IUserGoal[]> => {
  try {
    const res = await userGoalsApi.index({ user_id: userId })
    return res?.data.data ?? []
  } catch (error) {
    console.error('Ошибка получения целей:', error)
    return []
  }
}

export const removeUserGoal = async (goalId: number): Promise<boolean> => {
  try {
    const res = await userGoalsApi.remove({ id: goalId })
    return res?.data?.status === 'success'
  } catch (error) {
    console.error('Ошибка удаление цели:', error)
    return false
  }
}

export const createUserGoal = async (
  userId: number,
  goal: IUserGoal,
): Promise<IUserGoal | null> => {
  try {
    const { id, ...goalWithoutId } = goal

    const data = new FormData()
    data.append('user-id', String(userId))
    data.append('title', goalWithoutId.title)

    const res = await userGoalsApi.create(data)

    return res?.data?.data ?? null
  } catch (error) {
    console.error('Ошибка создания цели:', error)
    return null
  }
}

export const updateUserGoal = async (
  goal: IUserGoal,
): Promise<IUserGoal | null> => {
  try {
    const data = new FormData()
    data.append('id', String(goal.id))
    data.append('title', goal.title)

    const res = await userGoalsApi.update(data)

    return res?.data?.data ?? null
  } catch (error) {
    console.error('Ошибка обновления цели:', error)
    return null
  }
}
